import { render, staticRenderFns } from "./ShopsView.vue?vue&type=template&id=e571b392"
import script from "./ShopsView.vue?vue&type=script&lang=js"
export * from "./ShopsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports